<template>
    <section>
        <h1 class="mt-5 mb-3 text-center">Results</h1>

        <v-row>
            <v-col>
                <v-text-field
                        v-model="keyword"
                        label="Search"
                        hide-details
                >
                    <template v-slot:prepend-inner>
                        <svg v-svg="'icon-search'" size="15"></svg>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>

        <v-data-table :headers="headers"
                      :items="quizzes"
                      :page.sync="pagination.current"
                      :items-per-page="pagination.rowsPerPage"
                      hide-default-footer
                      class="elevation-1 mt-13 mb-6"
                      mobile-breakpoint="0"
        >
            <template v-slot:item.id="props">
                {{(pagination.current - 1)*pagination.rowsPerPage+props.index+1}}
            </template>

            <template v-slot:item.name_surname="props">
                {{props.item.user_name}} {{props.item.user_sur_name}}
            </template>

            <template v-slot:item.result="props">
                {{props.item.result}}%
            </template>

            <template v-slot:item.status="props">
                <span :class="getStatusClass(props.item.status)">
                    {{ getStatus(props.item.status) }}
                </span>
            </template>

            <template v-slot:item.actions="props">
                <v-btn text class="px-0" :href="props.item.pdf_link" target="_blank" v-if="props.item.status !== 1 && props.item.status !== 3">
                    <svg v-svg="'icon-show'" size="15" class="mr-1"></svg>
                    <span class="show">Show</span>
                </v-btn>
            </template>

            <template v-slot:header.actions class="d-none"></template>
        </v-data-table>

        <div class="float-end mb-5">
            <v-pagination  v-model="pagination.current"
                           :length="pagination.total"
                           :total-visible="3"
                           color="green"
                           @input="getData"
            ></v-pagination>
        </div>
    </section>
</template>

<script>
    export default {
        data(){
            return {
                timeout: null,
                loadingRequest: false,
                selectedSubject: null,
                keyword: null,
                headers: [
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: 'Student', sortable: false, value: 'name_surname'},
                    {text: 'Subject', sortable: false, value: 'course_name'},
                    {text: 'Total', sortable: false, value: 'total'},
                    {text: 'Result', sortable: false, value: 'result'},
                    {text: 'Status', sortable: false, value: 'status'},
                    {text: 'Team', sortable: false, value: 'team_name'},
                    {text: 'Date', sortable: false, value: 'created_at'},
                    {text: 'Actions', sortable: false, value: 'actions', align: 'center'}
                ],
                pagination: {},
                quizzes: [],
            }
        },

        mounted(){
            this.getData();
        },

        watch: {
            keyword() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.getData(1);
                }, 300);
            }
        },

        methods: {
            getData(page) {
                this.loadingRequest = true;
                this.$apiAdmin('quizzes').getResults({params: {page: page, keyword: this.keyword}}).then((res) => {
                    const response = res.data.results;
                    this.pagination.rowsPerPage = response.per_page;
                    this.pagination.current = response.current_page;
                    this.pagination.total = response.last_page;
                    this.quizzes = response.data;
                }).finally(() => {
                    this.loadingRequest = false;
                })
            },

            getStatus(id) {
                let statuses = ["PASSED", "WAITING", "FAILED","FINISHED"];
                return statuses[id] || '';
            },
            getStatusClass(id) {
                let statuses = ["green--text", "orange--text", "red--text", "green--text"];
                return statuses[id] || '';
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/pages/tablePages";
</style>